const maskName = str =>
  str.length <= 3
    ? str
    : str.split('').reduce((acc, item, index) => (index > 2 ? `${acc}*` : acc + item));

export default maskName;
